import _slicedToArray from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { MultiCallABI } from '../constants';
import { useMulticallAddress } from './useMulticallAddress';
import { useContractCall } from './useContractCall';
export function useEtherBalance(address) {
  var _a;

  var multicallAddress = useMulticallAddress();

  var _ref = (_a = useContractCall(multicallAddress && address && {
    abi: MultiCallABI,
    address: multicallAddress,
    method: 'getEthBalance',
    args: [address]
  })) !== null && _a !== void 0 ? _a : [],
      _ref2 = _slicedToArray(_ref, 1),
      etherBalance = _ref2[0];

  return etherBalance;
}